import React, { useEffect } from 'react';
import { Mail } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import PageHeader from '../common/PageHeader';
import Footer from '../common/Footer';

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <PageHeader />

      <div className="container py-12 md:py-12">
        <div className="mx-auto flex max-w-[980px] flex-col items-center gap-4 text-center mb-16">
          <Badge variant="outline">Kontakt</Badge>
          <h1 className="text-4xl font-bold tracking-tighter sm:text-5xl md:text-6xl">
            Kom i kontakt med oss
          </h1>
          <p className="max-w-[750px] text-lg text-muted-foreground">
            Vi finns här för att svara på dina frågor och hjälpa dig komma igång.
          </p>
        </div>

        <div className="flex justify-center max-w-lg mx-auto">
          <Card className="w-full">
            <CardHeader>
              <Mail className="h-8 w-8 mb-2" />
              <CardTitle>E-post</CardTitle>
              <CardDescription>Skicka oss ett meddelande</CardDescription>
            </CardHeader>
            <CardContent>
              <a href="mailto:info@dekalio.nu" className="text-lg font-medium hover:underline">
                info@dekalio.nu
              </a>
            </CardContent>
          </Card>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Contact;

